import {fabric} from 'fabric'
import moment from "moment"
import AnnotationLayer from "./annotation-layer"

function Page(pdfJsPage, viewport, pageContainer, zoom) {
  this.pageContainer = pageContainer
  this.pdfJsPage = pdfJsPage
  this.viewport = viewport
  this.zoom = zoom
  this.pdfAlreadyRendered = false
  this.annoLayer = null

  function buildThresholdList() {
    let thresholds = [];
    let numSteps = 20;

    for (let i=1.0; i<=numSteps; i++) {
      let ratio = i/numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    // console.log('IntersectionObserver.buildThresholdList', thresholds)
    return thresholds;
  }
  function handleIntersect(entries) {
    if (entries[0] && entries[0].intersectionRatio > 0) {
      this.render()
    }
  }
  const observer = new IntersectionObserver(handleIntersect.bind(this), {
    root: null,
    rootMargin: "10px",
    threshold: buildThresholdList()
  })
  observer.observe(pageContainer)
}

Page.prototype.render = function render() {
  const pdfCanvas = this.pageContainer.querySelector('canvas[data-type="pdf"]')
  this.pdfContext = pdfCanvas ? pdfCanvas.getContext('2d') : null
  this.renderPDF()
  this.renderAnnotations().catch(console.error)
}

Page.prototype.renderPDF = function renderPDF() {
  console.log(`Render page #${this.pdfJsPage._pageIndex}`, this.pdfJsPage)
  if (!this.pdfContext) return
  if (this.pdfAlreadyRendered) return

  this.pdfJsPage.render({
    canvasContext: this.pdfContext,
    viewport: this.viewport
  })
  this.pdfAlreadyRendered = true
}

Page.prototype.renderAnnotations = async function renderAnnotations() {
  const [,,width,height] = this.pdfJsPage._pageInfo.view
  const pdfViewport = {width, height}

  if (!this.annoLayer) {
    const annoCanvas = this.pageContainer.querySelector('canvas[data-type="annoLayer"]')
    this.annoLayer = new AnnotationLayer(this.pdfJsPage._pageIndex, annoCanvas, pdfViewport)
  }

  const annotations = []
  const embedAnnotations = await this.pdfJsPage.getAnnotations()
  console.log("Rendering annotations")
  console.log(embedAnnotations)
  embedAnnotations.filter(anno => anno.subtype === 'Link' && !!anno.url)
    .map(linkAnnotation => {
      // convert pdf link annotation to folia link annotation
      const now = moment().unix()
      const _rect = [
        linkAnnotation.rect[0],
        pdfViewport.height - linkAnnotation.rect[1] - (linkAnnotation.rect[3] - linkAnnotation.rect[1]),
        linkAnnotation.rect[2] - linkAnnotation.rect[0],
        linkAnnotation.rect[3] - linkAnnotation.rect[1]
      ]
      const x = fabric.util.toFixed(_rect[0]/pdfViewport.width * this.zoom, 8);
      const y = fabric.util.toFixed(_rect[1]/pdfViewport.height * this.zoom, 8);
      const w = fabric.util.toFixed(_rect[2]/pdfViewport.width * this.zoom, 8);
      const h = fabric.util.toFixed(_rect[3]/pdfViewport.height * this.zoom, 8);
      const rect = [x, y, w, h]
      const anno = {
        annoType: "link",
        type: "annotation",
        contents: linkAnnotation.contents,
        author: 'owner',
        created: now, lastModified: now,
        page: this.pdfJsPage._pageIndex,
        deleted: 0,
        object_id: linkAnnotation.id,
        rect,
        url: linkAnnotation.url,
      }
      annotations.push(anno)
    })
  this.annoLayer.addAnnotations(annotations)
}

export default Page
